import type { HmiCanvasDocument } from "../schema/hmi-canvas.schema";

import { buildBindingGraph, type HmiBindingGraphNode } from "./buildBindingGraph";

export type CompiledHmiRuntimeGraph = {
  documentVersion: number;
  bindings: HmiBindingGraphNode[];
  byElementId: Map<string, HmiBindingGraphNode[]>;
};

export function compileRuntimeGraph(document: HmiCanvasDocument): CompiledHmiRuntimeGraph {
  const bindings = buildBindingGraph(document);
  const byElementId = new Map<string, HmiBindingGraphNode[]>();
  for (const binding of bindings) {
    const bucket = byElementId.get(binding.elementId) ?? [];
    bucket.push(binding);
    byElementId.set(binding.elementId, bucket);
  }
  return {
    documentVersion: document.version,
    bindings,
    byElementId,
  };
}

